module.exports = __webpack_public_path__ + "img/mia-aa-north-terminal-development-pcs.8aa0e84a.png";